import axios from 'axios';

const baseApiUrl = 'api/admin/alarms';

export default class AlarmService {
  public findAll(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
